/**
 * Shared TanStack Query `refetchInterval` resolver for import-job status
 * polling. Reused by both `media-import/components/progress-phase.tsx`
 * and `availability-import/components/result-phase.tsx` — extracted
 * here (rather than imported across the feature boundary) per
 * `availability-import-ui/spec.md`'s cross-feature-import ban.
 *
 * Polls every 2s until a terminal status (`completed`/`failed`) is reached.
 */
export function refetchIntervalFn(status: string | undefined): number | false {
  return status === 'completed' || status === 'failed' ? false : 2000;
}
